module.exports = __webpack_public_path__ + "static/media/d-over-50-logo.f53fd969.png";